module.exports = __webpack_public_path__ + "src/assets/img/08.4d05b11a.png";